import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { defineMessages, useIntl } from 'react-intl';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useResetLastInteractedMenuStore } from '../../../../context/LastInteractedStore';
import { NotFoundView } from '../../../NotFoundView';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuContentError = () => {
  const router = useRouter();
  const { formatMessage } = useIntl();

  const resetLastInteractedMenuStore = useResetLastInteractedMenuStore();
  const isNavbarV2Enabled = useFeatureFlag('CELS-5440-order-navbar-v2-enabled');

  // ─── Helpers ─────────────────────────────────────────────────────────

  const changeLocation = useCallback(() => {
    router.navigate(isNavbarV2Enabled ? '/location-selection' : '/locations');
  }, [isNavbarV2Enabled, router]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <NotFoundView
      btnLabel={formatMessage(messages.ctaLabel)}
      onBtnPress={changeLocation}
      onMount={resetLastInteractedMenuStore}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  ctaLabel: {
    defaultMessage: 'Select another location',
    description: 'Menu | Error | Heading',
  },
});
